import { HttpInterceptorFn } from '@angular/common/http';
import { AuthApiService } from '../services/auth/auth-api.service';
import { inject } from '@angular/core';

export const tokenAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthApiService);
  const token = authService.token();

  if (
    req.url.includes('/register') ||
    req.url.includes('/login') ||
    req.url.includes('/refresh-token') ||
    req.url.includes('/oauth2') ||
    req.url.includes('/login/oauth2')
  ) {
    return next(req);
  }

  if (!token) {
    return next(req);
  }

  const headers = req.headers.set('Authorization', `Bearer ${token}`);

  const clonedRequest = req.clone({ headers: headers });

  return next(clonedRequest);
};
